app.directive("cdiCheckbox",function(){
   
    return {
      
        restrict:"E",
        scope:{
            label:"@",
            model:"="
        },
        templateUrl:"/assets/js/angular/components/directives/checkbox/checkbox.html"
        
    };
    
});

